import { SlimButton, ButtonVariants, Icon } from 'components'

import * as S from './styles'

import { theme } from 'styles/theme/hav-theme'

const ICON_SIZE = '16'

export type AlertVariants = 'success' | 'warning' | 'error' | 'info'
export interface AlertProps {
  kind: AlertVariants
  title: string
  message?: string | React.ReactNode
  messageOrientation?: 'right' | 'bottom'
  actionLabel?: string
  actionIcon?: React.ReactNode
  handleAction?: () => void
  fullWidth?: boolean
}

export const Alert: React.FC<AlertProps> = ({
  kind,
  title,
  message,
  messageOrientation = 'bottom',
  actionLabel,
  actionIcon,
  handleAction,
  fullWidth = false
}) => {
  const getIcon = () => {
    switch (kind) {
      case 'success':
        return (
          <Icon
            icon="task-alt"
            color={theme.colors.alert.success.dark}
            size={ICON_SIZE}
          />
        )
      case 'warning':
        return (
          <Icon icon="report" color={theme.colors.alert.warning.dark} size={ICON_SIZE} />
        )
      case 'error':
        return (
          <Icon icon="cancel" color={theme.colors.alert.danger.dark} size={ICON_SIZE} />
        )
      case 'info':
        return (
          <Icon icon="info" color={theme.colors.alert['info'].dark} size={ICON_SIZE} />
        )
    }
  }

  const buttonVariant: { [key in AlertVariants]: ButtonVariants } = {
    success: 'success',
    warning: 'warning',
    error: 'danger',
    info: 'primary'
  }

  return (
    <S.Container kind={kind} fullWidth={fullWidth}>
      <S.Texts>
        <S.TitleRow>
          {getIcon()}
          <strong>{title}</strong>
          {message && messageOrientation === 'right' && <span>{message}</span>}
        </S.TitleRow>
        {message && messageOrientation === 'bottom' && <span>{message}</span>}
      </S.Texts>
      {actionLabel && (
        <SlimButton
          variant={buttonVariant[kind]}
          content={actionLabel}
          icon={actionIcon}
          onClick={handleAction}
        />
      )}
    </S.Container>
  )
}
